<template>
    <div class="clearfix main_center" v-loading.fullscreen.lock="loading">
        <div class="top-content busWinessLeft">
            <div class="left-navbar">
                <el-button @click="back()" size="small">返回</el-button>
                <!-- <el-button @click="showAuditWindow(true,'通过')" plain size="small" type="primary"   v-show="filingCBtn && showHisAuditBtn">备案</el-button>
            <el-button @click="showAuditWindow(false,'不通过')" plain size="small" type="primary"  v-show="backCBtn && showHisAuditBtn" >退回</el-button> -->
                <el-button type="primary" plain size="small" @click="showAuditWindow(true, '通过')"
                    v-show="filingCBtn && showHisAuditBtn">备案</el-button>
                <el-button class="secondBtn" plain size="small" @click="showAuditWindow(false, '不通过')"
                    v-show="backCBtn && showHisAuditBtn">退回</el-button>
            </div>
        </div>
        <div class="right-content clearfix busWinessRight">
            <!--          <el-card class="box-card" style="position:relative;">-->
            <!--                <div slot="header" class="clearfix" >-->
            <!--                    <span>系统标识码</span>-->
            <!--                </div>-->
            <!--                <el-row :gutter="15" >-->
            <!--                    <el-form label-width="200px">-->
            <!--                    <el-col :span="12">-->
            <!--                        <el-form-item label="交易系统标识码：" prop='personName' style="width:100%;">-->
            <!--                            {{platformCode}}-->
            <!--                        </el-form-item>-->
            <!--                    </el-col>-->
            <!--                    <el-col :span="12">-->
            <!--                        <el-form-item label="公共服务平台标识码：" prop='idcard' style="width:100%;">-->
            <!--                            {{pubServicePlatCode}}-->
            <!--                        </el-form-item>-->
            <!--                    </el-col>-->
            <!--                    </el-form>-->
            <!--                </el-row>-->
            <!--            </el-card>-->

            <customForm v-if="customFormShow" ref="customFormRef" :auditHisTable.sync="auditHisTable"
                :entityId.sync="entityId" :categoryCode.sync="categoryCode" :filingCBtn="filingCBtn"
                :nodeCode.sync="nodeCode" :baseURL.sync="baseURL">
            </customForm>

            <customFormOther v-if="customFormOtherShow" ref="customFormOtherRef" :auditHisTable.sync="auditHisTable"
                :entityId.sync="entityId" :categoryCode.sync="categoryCode" :purchaserMode.sync="purchaserMode"
                :nodeCode.sync="nodeCode">
            </customFormOther>

            <el-card class="box-card" v-if="!customFormShow && !customFormOtherShow"
                style="height: 700px;position: relative;margin-bottom: 10px">
                <emptyInfo v-if="groupList.length == 0" :emptyMsg="'暂无表单数据'"></emptyInfo>
            </el-card>

        </div>


        <!-- auditForm.isPass?'是否将表单中的预警提醒进行【忽略】操作':'是否将表单中的预警提醒进行【处理】操作' -->
        <el-dialog title="意见" :visible.sync="dialogVisible" width="30%">
            <div class="dialogBox">
                <el-form ref="auditForm" :model="auditForm" label-width="90px" class="form">
                    <el-form-item label="处理意见:" style="width:90%;">
                        <el-input type="textarea" :rows="6" v-model="auditForm.suggest" show-word-limit
                            maxlength="100"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" v-debounce="[auditProcess, 'click', 300]" style="margin-bottom:20px;">确
                    定</el-button>
                <el-button @click="dialogVisible = false" class="backBtn">返回</el-button>
            </span>
        </el-dialog>

    </div>
</template>

<script>
import customForm from '@/components/customForm';
import emptyInfo from '@/components/empty-info';
import customFormOther from '@/components/customFormOther';
import { mapState } from "vuex";
// import {tabsCloseCurrentHandle} from '@/utils/routeTab';


export default {
    components: {
        customForm,
        emptyInfo,
        customFormOther
    },
    data() {
        return {
            id: "",
            baseURL: "",
            categoryCode: "",
            platformCode: "",
            pubServicePlatCode: "",
            customFormShow: true,
            nodeCode: "",
            purchaserMode: "",// 采购方式
            customFormOtherShow: false,
            taskId: '',
            form: {
                id: '',
                historyid: '-1',
                processinstanceid: "",
                processinstancecreatedate: "",
                businessType: "",
                entityId: "",
                flowId: '',
                tenderProjectCode: '',
                bidSectionCode: '',
                projectCode: '',
                personHandle: 1,  //人工干预见证
                rejectCode: '',
            },
            listNav: ['项目信息', '中选信息', '附件信息'],
            auditForm: {
                isPass: null,
                suggest: ''
            },
            dialogVisible: false,
            auditHisTable: [], // 变更历史
            loading: false,
            user: '',
            pageSize: 10,//每页条数
            pageIndex: 1,//当前页
            total: 0,//总条数
            processSubmit: false,
            customFormData: {},
            filingCBtn: false,
            backCBtn: false,
            dataId: 0,
            getFlowDataByFlag: true,
            paramMap: {
                categoryIsOpen: '', // 附件约束条件
                enableHandle: false, // 是否支持受理
                tenderProjectCode: '',
                bidSectionCode: '',
                datasetCode: "",
                projectCode: '',
                applyCode: "",
                idcard: "",
            },
            formId: '',
            groupList: [],
            formInfo: {},
            tableData: [],


        }
    },

    filters: {

    },
    created() {

    },
    computed: {
        ...mapState({
            stateData: state => state.user
        }),
        businessType: function () {
            return this.form.businessType;
        },
        showHisAuditBtn: function () {
            return this.form.historyid < 0;
        },
        processinstanceid: function () {
            return this.form.processinstanceid;
        },
        entityId: function () {
            return this.form.entityId;
        },

    },

    activated() {
        // $route.query.id为首页通过 url跳转 带过来的参数
        this.id = (this.$route.query && this.$route.query.id) || (this.$route.params && this.$route.params.id) || '';
        this.purchaserMode = this.$route.query && this.$route.query.purchaserMode
        this.getDetailById();
    },

    methods: {
        //列表查看进来根据id查询详情
        getDetailById() {

            if (this.id) {

                // 查询基本信息及流程id
                this.$httpReq.get('/businessFlowWitness/get?id=' + this.id).then(res => {
                    if (res.data.code === '1') {

                        this.form = { ...res.data.data };

                        this.getFlowDataByFlag = res.data.data.signFlag;
                        this.form.entityId = res.data.data.entityId;


                        this.processSubmit = false;
                        this.filingCBtn = false;
                        this.backCBtn = false;
                        this.paramMap.tenderProjectCode = res.data.data.tenderProjectCode || '';
                        this.paramMap.bidSectionCode = res.data.data.bidSectionCode || '';
                        this.paramMap.projectCode = res.data.data.projectCode || '';
                        // if(this.paramMap.tenderProjectCode){
                        //     this.$httpReq.get(`/tenderProject/getTenderProjectByCode?tenderProjectCode=${this.paramMap.tenderProjectCode}&busiType=${this.businessType}`).then(res=>{
                        //         if(res.data.code==='1'){
                        //             this.platformCode = res.data.data.platformCode || '';
                        //             this.pubServicePlatCode = res.data.data.pubServicePlatCode || '';
                        //
                        //         }
                        //     })
                        // }

                        this.getFormIdByFlowid(res.data.data.flowId);

                        if (this.getFlowDataByFlag) {
                            this.getFlow(this.processinstanceid);
                        }

                        if (this.form.flowName == "招标项目信息" && this.form.witnessStatus == 1) {
                            this.checkPlanDate(this.form.businessCode);
                        }

                    }
                })

            } else {
                this.$router.push({
                    name: 'home'
                })
            }

        },


        // 返回
        back() {
            tabsCloseCurrentHandle();
            this.$router.push({
                name: 'busWitness_list',
            })

        },


        showAuditWindow(isPass, msg) {
            this.dialogVisible = true;
            this.auditForm.suggest = msg;
            this.auditForm.isPass = isPass;
        },

        // 见证
        auditProcess() {
            this.loading = true;
            this.$httpReq.post('/businessFlowWitness/processSubmit', {
                id: this.id,
                taskId: this.taskId,
                businessType: this.businessType,
                processinstanceid: this.processinstanceid,
                variables: {
                    commit: this.auditForm.isPass,
                    opinion: this.auditForm.suggest //监督意见
                },
                entityId: this.entityId,
                personHandle: this.form.personHandle,  //1:人工干预见证
            }).then(res => {

                this.dialogVisible = false;
                this.loading = false;
                if (res.data.code == 1) {

                    this.$message({
                        type: 'success',
                        message: '操作成功。'
                    })

                    this.processSubmit = false;
                    this.filingCBtn = false;
                    this.backCBtn = false;

                    if (this.getFlowDataByFlag) {
                        this.getFlow(this.processinstanceid);
                    }

                    // this.getAuditHisList()

                    const that = this;
                    // 支持自定义表单数据
                    if (this.customFormShow) {
                        setTimeout(function () {
                            that.$refs.customFormRef.getAuditHisList(that.entityId);
                        }, 100)
                    }

                    if (this.customFormOtherShow) { // 定制化表单数据
                        setTimeout(function () {
                            that.$refs.customFormOtherRef.getAuditHisList(that.entityId);
                        }, 100)
                    }


                    // 此处对交易数据预警里面的预警项进行处理或者忽略操作
                    //   var opinion = this.auditForm.isPass?'在项目见证受理时，对该数据执行同意操作':'在项目见证受理时，对该数据执行驳回操作';
                    //   var historyId = this.auditForm.isPass?1:0;
                    //   var params = {
                    //       entityId:this.entityId,
                    //       opinion:this.auditForm.isPass?'在项目见证受理时，对该数据执行同意操作':'在项目见证受理时，对该数据执行驳回操作',
                    //       historyId:this.auditForm.isPass?1:0,
                    //   };
                    //   this.$httpReq.get(`/jzWarnRecords/handleByEntityId?entityId=${this.entityId}&opinion=${opinion}&historyId=${historyId}`).then(res=>{
                    //       if(res.data.code ==1){
                    //           this.$message({
                    //               type:'success',
                    //               message: res.data.msg
                    //           })
                    //       }
                    //   })



                } else {
                    if (res.data.msg != null && res.data.msg != '') {
                        this.$message({
                            type: 'error',
                            message: res.data.msg
                        })
                    } else {
                        this.$message({
                            type: 'error',
                            message: '流程提交失败。'
                        })
                    }
                }

            })
        },



        //获取流程
        getFlow(id) {
            this.$httpReq.get(`/workflow/getInfo?processInstanceid=${id}`).then(res => {
                if (res.data.data.taskId !== '') {
                    this.taskId = res.data.data.taskId;
                    res.data.data.buttons.forEach(item => {

                        if (item.type == 1) {
                            this.processSubmit = true;
                        }
                        if (item.type == 2) {
                            this.filingCBtn = true
                        }
                        if (item.type == 3) {
                            this.backCBtn = true
                        }
                    })

                }


            }).catch(e => {

            })
        },



        getFormIdByFlowid(flowid) {
            // 根据jz_businessflow_witness的formid得到sys_flownode_config的form_id
            this.$httpReq.get('/configs/sysFlowNodeConfig/get?id=' + flowid).then(res => {
                if (res.data.code === '1') {
                    this.categoryCode = res.data.data.categoryCode;
                    this.nodeCode = res.data.data.nodeCode;
                    this.paramMap.categoryIsOpen = res.data.data.categoryIsOpen;
                    this.paramMap.enableHandle = res.data.data.enableHandle;
                    this.paramMap.datasetCode = res.data.data.datasetCode || '';
                    if (res.data.data.enableCustom == 1) {
                        this.customFormShow = true;
                        this.customFormOtherShow = false;
                    } else {
                        this.customFormShow = false;
                        this.customFormOtherShow = true;
                    }
                    this.initData(res.data.data.formId);
                } else {
                    this.$message({
                        type: 'error',
                        message: res.data.msg
                    })
                }

            })
        },




        // 获取自定义表单或定制化表单数据
        initData(formid) {



            // 支持自定义表单数据
            if (this.customFormShow) {
                if (formid == '' || formid === undefined) {
                    this.$message.error('数据集无效')
                    return
                }
                const that = this;

                setTimeout(function () {
                    let entityId = that.entityId || '';
                    let hasEntityId = entityId ? true : false;
                    that.paramMap.id = entityId;
                    that.$refs.customFormRef.getCustomData(formid, that.paramMap, !hasEntityId, entityId);
                }, 100)

            }
            if (this.customFormOtherShow) { // 定制化表单数据
                const that = this;
                setTimeout(function () {
                    that.$refs.customFormOtherRef.getCustomData(that.paramMap, that.nodeCode, that.purchaserMode);
                }, 100)
            }



        },

        checkPlanDate(projectCode) {
            this.$httpReq.get('/projectPlan/getProjectPlanOverDay?tenderProjectCode=' + projectCode).then(res => {
                if (res.data.code == 1) {
                    if (!res.data.data) {
                        this.$message.warning("该项目招标计划发布时间未达到 30 日历天，请知悉。");
                    }
                }
            })
        },
    },
    deactivated() {
    },

}
</script>

<style lang="scss" scope>
.right-content.busWinessRight {
    width: calc(100% - 160px);
}

.left-content.busWinessLeft {
    .left-navbar {
        width: 150px;
        border: none;
    }
}
</style>
